import { memo } from "react";

import { Source, Finding } from "stores/FindingStore";

import AWSFinding from "external/source/aws/FindingDetails";
import BoxFinding from "external/source/box/FindingDetails";
import NoneFinding from "external/source/none/FindingDetails";

// -----------------------------------------------------------------------------

const ServiceFindingDetails: { [prop: number]: Function } = {
  [Source.Box]: BoxFinding,
  [Source.AWSScan]: AWSFinding,
  [Source.AWSCloudTrail]: AWSFinding,
};

// -----------------------------------------------------------------------------

const FindingDetailsRow = memo(function FindingDetailsRow({
  finding,
}: FindingDetailsRowProps) {
  const Component: Function =
    ServiceFindingDetails[finding.source] || NoneFinding;

  //
  return <Component finding={finding} />;
});

export default FindingDetailsRow;

// -----------------------------------------------------------------------------

interface FindingDetailsRowProps {
  finding: Finding;
}
